<template>
  <div
    class="
      content-wrapper
      row
      align-items-center
      justify-content-center
      sticky-top
    "
  >
    <div class="row justify-content-center inlay-name">
      <div class="col-8">
        <div class="row text-start">
          <label class="col-form-label col-sm-4" for="inlay_name">{{
            t("message.inlayName")
          }}</label>
          <div class="col-sm-8">
            <input
              class="form-control"
              type="text"
              name=""
              id="inlay_name"
              :value="inlayName"
              @input="changeInlayName"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-center"
      v-if="showSmallKeys() && showSuggestion"
    >
      <div class="col-7">
        {{ t("message.changeToSmallerKeys") }}
        <img src="@/assets/images/layoutBargr.png" class="mx-3 my-1" alt="" />
        <div class="row justify-content-center">
          <div class="col-5">
            <button
              class="btn btn-outline-lcn p-1 m-1"
              @click="changeInlayKeys(true)"
            >
              {{ t("message.yes") }}
            </button>
            <button
              class="btn btn-outline-lcn p-1 m-1"
              @click="changeInlayKeys(false)"
            >
              {{ t("message.no") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- GT6L Preview -->
    <template v-if="gt.name.includes('gt6l')">
      <div
        class="slider-container col-sm-1"
        :style="{
          width: gt.gtDim.width / 3 + 'px',
          height: gt.gtDim.height / 3 + 'px',
        }"
      >
        <div
          class="inlay"
          :style="{
            'background-color': gt.preview.style['background-color'],
            'background-image': gt.preview.style['background-image'],
            'background-size': gt.preview.style['background-size'],
            height: tinyView(gt.preview.style.height, 'i-heihgt'),
            top: tinyView(gt.preview.style.top, 'i-top'),
            left: tinyView(gt.preview.style.left, 'i-left'),
            width: tinyView(gt.preview.style.width, 'i-width'),
          }"
        ></div>
        <div
          v-for="(inlay, index) in gt.inlay"
          :key="index"
          @click="switchGT6L(index)"
        >
          <div
            class="gt-btn"
            :class="{ selected: currentGT6L == index }"
            v-for="(btn, btn_index) in inlay.btns"
            :key="'index_' + btn_index"
            :style="{
              height: tinyView(btn.style.height, 'btn-height'),
              width: tinyView(btn.style.width, 'btn-width'),
              background: btn.style.background,
              'background-image': btn.style['background-image'],

              'background-size': btn.style['background-size'],
              top: tinyView(btn.style.top, 'btn-top', index),
              left: tinyView(btn.style.left, 'btn-left', index),
              border: btn.style['border-color']
                ? '1px solid ' + btn.style['border-color']
                : '',
              'border-radius': btn.style['border-radius'],
              'background-position': 'top',
            }"
          >
            <div
              class="gt-btn-img"
              :style="{
                'background-image': btn.style.image['background-image'],
                'background-position': btn.style.image['background-position'],
                'background-size': btn.style.image['background-size'],
                filter: btn.style.image.filter,
                height: tinyView(btn.style.height, 'btnimg-height'),
                width: tinyView(btn.style.width, 'btn img-width'),
              }"
            >
              <!-- {{ btn.style.background }} -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <glass-taster :gt="gt" :editor="true"></glass-taster>
    <div class="row justify-content-center mt-3">
      <button
        class="btn btn-outline-lcn col-4"
        v-if="gt.group == 'gt6l'"
        @click="changeOrientation"
      >
        {{
          gt.gtDim.height > gt.gtDim.width
            ? t("message.changeOrientationHorizontal")
            : t("message.changeOrientationVertical")
        }}
      </button>
      <button
        class="btn btn-outline-lcn col-4"
        v-if="gt.group == 'gt2t'"
        @click="changeGT2TOrientation"
      >
        {{
          gt.inlay.btns[0].style.height == "54mm"
            ? t("message.changeOrientationHorizontal")
            : t("message.changeOrientationVertical")
        }}
      </button>
      <button
        class="btn btn-outline-lcn col-4"
        v-if="gt.group == 'gt12'"
        @click="changeGT12Orientation"
      >
        {{ t("message.changeOrientation") }}
      </button>
    </div>
    <div class="row justify-content-center m-3">
      <div
        class="m-2"
        @click="changeGTBackground('black')"
        style="
          background: black;
          height: 30px;
          width: 30px;
          border-radius: 50%;
          cursor: pointer;
        "
      ></div>
      <div
        class="m-2"
        @click="changeGTBackground('#f7e7ce')"
        style="
          background: #f7e7ce;
          height: 30px;
          width: 30px;
          border-radius: 50%;
          cursor: pointer;
        "
      ></div>
      <div
        class="m-2"
        @click="changeGTBackground('white')"
        style="
          background: white;
          height: 30px;
          width: 30px;
          border-radius: 50%;
          border: 1px solid black;
          cursor: pointer;
        "
      ></div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import GlassTaster from "../GTComponent.vue";
import { currentInlay } from "../../store/getters";

export default {
  name: "DesignerContent",
  components: { GlassTaster },
  setup() {
    const store = useStore();
    const inlayName = computed(() => store.getters.currentInlayProjectName);
    const gt = computed(() => store.getters.currentInlay);
    const showSuggestion = ref(true);
    const { t } = useI18n();
    const currentGT6L = computed(() => store.getters.currentGT6LInlay);
    function changeInlayName(evt) {
      store.dispatch("changeInlayName", evt.target.value);
    }
    function changeGTBackground(color) {
      store.dispatch("switchGTBackground", color);
    }
    function showSmallKeys() {
      if (
        gt.value.name.includes("gt12 12+8 2013") ||
        gt.value.name.includes("gt12 8,1+6 2013") ||
        gt.value.name.includes("gt12 6+2 2013") ||
        gt.value.name.includes("gt12 8,1+6 2013") ||
        gt.value.name.includes("gt12 2,1+2 2013")
      ) {
        if (gt.value.inlay.showBargraph) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    }
    function changeInlayKeys(value) {
      if (value) {
        store.commit("changeInlayKeys");
        showSuggestion.value = false;
        store.commit("setSmallKeys", true);
      } else showSuggestion.value = false;
    }
    function changeOrientation() {
      let currentDim = {
        width: gt.value.gtDim.width,
        height: gt.value.gtDim.height,
        botHeight: gt.value.gtDim.botHeight,
        topHeight: gt.value.gtDim.topHeight,
        rWidth: gt.value.gtDim.rWidth,
        lWidth: gt.value.gtDim.lWidth,
      };

      let currentBtns = [];
      for (let inlay in gt.value.inlay) {
        currentBtns.push(gt.value.inlay[inlay].btns);
        gt.value.inlay[inlay].style.horizontal =
          !gt.value.inlay[inlay].style.horizontal;
      }
      let currentLEDs = gt.value.inlay[currentGT6L.value].leds;
      let currentInlayDim = gt.value.inlay[currentGT6L.value].style;
      let previewBtns = gt.value.preview.btns;
      store.commit("changeOrientation", {
        gtDim: currentDim,
        inlayDim: currentInlayDim,
        leds: currentLEDs,
        btns: currentBtns,
        preBtns: previewBtns,
      });
    }
    function changeGT2TOrientation() {
      gt.value.inlay.style.horizontal = !gt.value.inlay.style.horizontal;

      let currentDim = gt.value.gtDim;
      let currentBtns = gt.value.inlay.btns;
      let currentLEDs = gt.value.inlay.leds;
      let currentInlayDim = gt.value.inlay.style;
      store.commit("changeGT2TOrientation", {
        gtDim: currentDim,
        inlayDim: currentInlayDim,
        leds: currentLEDs,
        btns: currentBtns,
      });
    }
    function changeGT12Orientation() {
      gt.value.inlay.style.horizontal = !gt.value.inlay.style.horizontal;

      let currentDim = gt.value.gtDim;
      let currentBtns = gt.value.inlay.btns;
      let currentLEDs = gt.value.inlay.leds;
      let currentInlayDim = gt.value.inlay.style;
      let currentInlayBargraph = gt.value.inlay.bargraph;
      store.commit("changeGT12Orientation", {
        gtDim: currentDim,
        inlayDim: currentInlayDim,
        leds: currentLEDs,
        btns: currentBtns,
        bargraph: currentInlayBargraph,
      });
    }

    function switchGT6L(index) {
      store.commit("switchGT6L", index);
      store.commit("selectBtns", []);
    }
    //Returns the reduced size for a given css size value - this is used for the GT6L Preview
    function tinyView(mmValue, trigger, index = null) {
      let smol = "";

      if (
        (trigger == "btn-top" &&
          gt.value.inlay[currentGT6L.value].btns[0].style.width == "24mm") ||
        (trigger == "btn-left" &&
          gt.value.inlay[currentGT6L.value].btns[0].style.width != "24mm")
      ) {
        smol =
          ((parseFloat(mmValue.substring(0, mmValue.length - 2)) + index * 94) *
            3.7795275591) /
          3;
      } else {
        smol =
          (parseFloat(mmValue.substring(0, mmValue.length - 2)) *
            3.7795275591) /
          3;
      }
      return smol + "px";
    }

    return {
      gt,
      store,
      inlayName,
      changeInlayName,
      changeGTBackground,
      showSmallKeys,
      changeInlayKeys,
      showSuggestion,
      t,
      changeOrientation,
      changeGT2TOrientation,
      changeGT12Orientation,
      tinyView,
      switchGT6L,
      currentGT6L,
    };
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  min-height: 450px;
  max-height: 800px;
}
.inlay-name {
  margin-top: 50px;
}

.slider-container {
  // display: block;
  border: 2px solid grey;
  border-radius: 5px;
  position: relative;
  margin-top: 30px;
  margin-right: 30px;
  overflow: hidden;
  p {
    margin-bottom: 5px !important;
    z-index: 100;
    white-space: pre-line;
  }
}
.gt-btn {
  border: 1px dashed grey;
  position: absolute;
  display: grid;
}
.gt-btn-img {
  background-repeat: no-repeat;
  z-index: 5;
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  pointer-events: none;
}

.inlay {
  position: absolute;
  background-repeat: no-repeat;
}
.gt-top,
.gt-bottom {
  position: absolute;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.gt-top {
  top: 0;
}
.gt-bottom {
  bottom: 0;
}
.gt-right,
.gt-left {
  position: absolute;
  z-index: 10;
  background-color: #fff;
}
.gt-right {
  right: 0;
}
.gt-left {
  left: 0;
}

.inlay-name {
  margin-top: 50px;
}
.gt-btn-container {
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  pointer-events: auto;
}
.led {
  position: absolute;
  background-color: white;
  border: 1px dashed gray;
}
.bar_g {
  position: absolute;
  cursor: pointer;
}
.selected {
  border: 2px dashed red;
}
.bar_g_caption {
  position: absolute;
  font-size: 10px;
  line-height: 2.18mm;
  font-weight: bold;
}
.move {
  cursor: move;
}
.gt10d-button {
  width: 22mm;
  border: 1px solid grey;
  position: absolute;
}
.btn_text {
  word-break: break-word;
}
</style>
